export default {
  priv: 'inspection_tc|inspection_site', // this needs to change per type
  overviewTitle: 'Keuringen',
  detailTitle: 'Keuring',
  deleteTitle: 'deze Keuring',
  url: '/tc/inspections',
  apiUrl: '/inspections/',
  sortBy: ['name'],
  sortDesc: [true],
  deletable: false,
  customDeletable(context, item) {
    return context.roleCheck('inspection_tc|inspection_site', 'manage'); // this needs to change per type
  },
  editable: true,
  filterName: 'inspections',
  quickFilter: {
    text: 'Zoek op keurder, rapport, serienr, installatienr',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Gepland van', value: 'planned_date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Gepland tot', value: 'planned_date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Status', value: 'processstate_id', type: 'optionList', optionListName: 'processstates', columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Keurder', value: 'inspector_id', type: 'optionList', optionListName: 'users', optionListParams: {is_inspector: true}, columns: 3, labelCols: 3, inputCols: 9}
  //   {text: 'Chauffeur', value: 'driver_id', type: 'optionList', optionListName: 'drivers', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9},
  //   {text: 'Niet leeg', value: 'not_empty', type: 'boolean', columns: 1, labelCols: 9, inputCols: 3},
  //   {text: 'Niet gefactureerd', value: 'not_invoiced', type: 'boolean', columns: 1, labelCols: 9, inputCols: 3},
  //   {text: 'Firma', value: 'company_id', type: 'optionList', optionListName: 'companies', optionListParams: {is_active: true}, columns: 2, labelCols: 3, inputCols: 9},
  //   {text: 'Dossier', value: 'dossier', columns: 2, labelCols: 3, inputCols: 9},
  //   {text: 'Bestemming', value: 'destination', columns: 3, labelCols: 3, inputCols: 9},
  //   {text: 'Voertuig', value: 'truck_id', type: 'optionList', optionListName: 'vehicles', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9},
  //   {text: 'Project Bestemming', value: 'project_destination', columns: 3, labelCols: 3, inputCols: 9},
  //   {text: 'Project CMR', value: 'project_cmr', columns: 3, labelCols: 3, inputCols: 9},
  //   {text: 'Project Nr', value: 'project_projectnr', columns: 3, labelCols: 3, inputCols: 9}
  ],
  newRecord: {
    preparations: []
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Naam', value: 'name', link: '/tc/inspections/{id}', width: '5%'},
    {text: 'Rapport Code', value: 'bd_sitereport_report_code', width: '5%'},
    {text: 'Site Naam', value: 'site_name', width: '25%'},
    {text: 'Status', value: 'processstate_name_nl', width: '10%'},
    {text: 'Srvrijk', value: 'inspector1', filter: 'shortname', width: '2%'},
    {text: 'Keur2', value: 'inspector2', filter: 'shortname', width: '2%'},
    {text: 'Keur3', value: 'inspector3', filter: 'shortname', width: '2%'},
    {text: 'Certif', value: 'responsible', filter: 'shortname', width: '2%'},
    {text: 'Gepland', value: 'planned_date', width: '6%'},
    {text: 'Deadline', value: 'due_date', width: '6%'},
    {text: 'Remarks', value: 'remarks', filter: 'firstline', width: '10%'}
  ]
};
